import axios from 'axios';
import config from '../config/config';
import {PRINTER_GET_AVAILABLES_PRINTERS_SUCCESS, PRINTER_SET_PRINTER} from "../config/actions";

export function getAvailablePrintersSuccess(availablePrinters) {
    return {
        type: PRINTER_GET_AVAILABLES_PRINTERS_SUCCESS,
        availablePrinters: availablePrinters
    }
}

export function getAvailablePrinters() {
    return dispatch => {
        axios(config.server.endpoint + 'backend/printer/available/', {
            method: 'get',
            silentErrors: true
        }).then((response) => {
            if (response.status === 200 && response.data.success) {
                dispatch(getAvailablePrintersSuccess(response.data.data || []));
            }
        }).catch(() => {
            dispatch(getAvailablePrintersSuccess([]));
        });
    }
}

export function setPrinter(selectedPrinter) {
    return {
        type: PRINTER_SET_PRINTER,
        selectedPrinter: selectedPrinter
    }
}
